import React, { useState } from "react";
import { Col, CustomInput, Form, FormGroup, Input, Label, Row } from "reactstrap";

type Props = Readonly<{
  resetThreshold: () => void;
  setThreshold: (threshold: number) => void;
  showAll: boolean;
  threshold: number;
  toggleShowAll: () => void;
}>;

export const Filters = ({
  resetThreshold,
  setThreshold,
  showAll,
  threshold,
  toggleShowAll,
}: Props) => {
  const [expanded, setExpanded] = useState(false);
  const formattedThreshold = Math.round(threshold * 100);
  let filtersClass = "filters";
  if (expanded) {
    filtersClass = "filters expanded";
  }
  return (
    <div className={filtersClass}>
      <div
        className="label"
        onClick={() => {
          setExpanded(!expanded);
        }}
      >
        <h5>
          <u>Filters</u>
          <i className="fa fa-sliders ml-2" />
        </h5>
        <i className="fa fa-angle-down" />
      </div>
      <Form>
        <Row>
          <Col>
            <h6>
              <strong>Confidence</strong>
            </h6>
          </Col>
        </Row>
        <FormGroup check row>
          <Col>
            <Label check className={showAll ? "text-muted" : ""}>
              <Input checked={!showAll} onChange={toggleShowAll} type="checkbox" /> Hide pages
              above: <strong className="threshold-label">{formattedThreshold}%</strong>
            </Label>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col className="pr-0">
            <CustomInput
              disabled={showAll}
              id="page-confidence-slider"
              onChange={e => {
                setThreshold(parseFloat(e.target.value));
              }}
              max={1}
              min={0}
              step={0.01}
              type="range"
              value={threshold}
            />
          </Col>
          <Col xs="auto">
            <a
              className={showAll ? "text-muted" : "text-white"}
              href="#"
              onClick={e => {
                e.preventDefault();
                if (showAll) {
                  return;
                }
                resetThreshold();
              }}
              title="Reset"
            >
              <i className="fa fa-rotate-left" />
            </a>
          </Col>
        </FormGroup>
      </Form>
    </div>
  );
};
Filters.displayName = "Filters";
